exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".underline[data-v-00033a06]{border-bottom:1px dashed #42bec2}", ""]);

// exports
